import dayjs from 'dayjs';
import classNames from 'classnames';
import { Tooltip } from 'primereact/tooltip';

import { ColumnDescription } from '@/components/common/ui/table/ColumnDescription';
import { Pagination } from '@/types/pagination';
import { paymentStatusText } from '@/shared/constants/payment';

export const PaymentColumns = (
  t: any,
  pagination?: Pagination,
): ColumnDescription[] => [
  {
    dataField: 'index',
    text: t('payment_list.id'),
    headerClassname: 'text-center w-[80px]',
    classname: 'w-[80px] text-gray-700 text-center',
    formatter: (rowData, index) => {
      const pageOffset = ((pagination?.paginate ?? 1) - 1) * 10;
      return index.rowIndex + pageOffset + 1;
    },
  },
  {
    dataField: 'coach_name',
    text: t('payment_list.coach_name'),
    headerClassname: 'w-[112px]',
    classname: 'w-[112px]',
    formatter: (rowData) => {
      return (
        <>
          <Tooltip target={`.tooltip-point-${rowData.id}-coach-name`}>
            {rowData.user_payment_details.full_name_kanji}
          </Tooltip>
          <div
            className={classNames(
              'line-clamp-1 text-gray-700 break-all',
              `tooltip-point-${rowData.id}-coach-name`,
            )}
            data-pr-position="top"
          >
            {rowData.user_payment_details.full_name_kanji}
          </div>
        </>
      );
    },
  },
  {
    dataField: 'period_number',
    text: t('payment_list.graduation'),
    headerClassname: 'w-[141px] text-center',
    classname: 'w-[141px] text-center',
    sort: true,
    formatter: (rowData) => {
      return <div>{rowData.graduations.period_number}</div>;
    },
  },
  {
    dataField: 'student_name',
    text: t('payment_list.student_name'),
    headerClassname: 'w-[128px] text-center',
    classname: 'w-[128px] text-center',
    formatter: (rowData) => {
      return (
        <>
          <Tooltip
            target={`.tooltip-point-payment-name-${rowData.id}-student-name`}
          >
            {rowData.user_payment_details.payment_name}
          </Tooltip>
          <div
            className={classNames(
              'line-clamp-1 text-gray-700 break-all',
              `tooltip-point-payment-name-${rowData.id}-student-name`,
            )}
            data-pr-position="top"
          >
            {rowData.user_payment_details.payment_name}
          </div>
        </>
      );
    },
  },
  {
    dataField: 'student_email',
    text: t('payment_list.student_email'),
    headerClassname: 'w-[164px]',
    classname: 'w-[164px]',
    formatter: (rowData) => {
      return (
        <>
          <Tooltip
            target={`.tooltip-point-${rowData.id}-student-mail`}
          >
            {rowData.user_payment_details.email}
          </Tooltip>
          <div
            className={classNames(
              'line-clamp-1 text-gray-700 break-all',
              `tooltip-point-${rowData.id}-student-mail`,
            )}
            data-pr-position="top"
          >
            {rowData.user_payment_details.email}
          </div>
        </>
      );
    },
  },
  {
    dataField: 'phone',
    text: t('payment_list.phone'),
    headerClassname: 'w-[140px]',
    classname: 'w-[140px]',
    formatter: (rowData) => {
      return <div>{rowData.user_payment_details.phone_number}</div>;
    },
  },
  {
    dataField: 'plan_name',
    text: t('payment_list.plan_name'),
    headerClassname: 'w-[141px]',
    classname: 'w-[141px]',
    formatter: (rowData) => {
      return (
        <>
          <Tooltip
            target={`.tooltip-point-${rowData.id}-plan`}
          >
            {rowData.plans.name}
          </Tooltip>
          <div
            className={classNames(
              'line-clamp-1 text-gray-700 break-all',
              `tooltip-point-${rowData.id}-plan`,
            )}
            data-pr-position="top"
          >
            {rowData.plans.name}
          </div>
        </>
      );
    },
  },
  {
    dataField: 'created_on',
    text: t('payment_list.charge_time'),
    headerClassname: 'w-[141px] text-center',
    classname: 'w-[141px] text-gray-700 text-center',
    sort: true,
    formatter: (rowData) => (
      <div>
        {rowData.created_on
          ? dayjs(rowData.created_on.toString()).format('YYYY/MM/DD')
          : '-'}
      </div>
    ),
  },
  {
    dataField: 'status',
    text: t('graduation_list.status'),
    headerClassname: 'w-[111px]',
    classname: 'w-[111px] text-gray-700',
    formatter: (rowData) => (
      <div className="w-full flex justify-center">
        {rowData.transaction_status === paymentStatusText.SUCCESS && (
          <div className="rounded-2xl bg-primary-50 text-primary-700 text-md font-medium leading-4 w-[52px] h-[24px] flex justify-center items-center">
            {t('payment_list.payment_success')}
          </div>
        )}

        {rowData.transaction_status === paymentStatusText.FAIL && (
          <div className="rounded-2xl bg-gray-100 text-gray-700 text-md font-medium leading-4 w-[52px] h-[24px] flex justify-center items-center">
            {t('payment_list.payment_fail')}
          </div>
        )}
      </div>
    ),
  },
];
